import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ProductVariantMediaBulkRequest as SchemaProductVariantMediaBulkRequest } from '../schemas/ProductVariantMediaBulkRequest';
import { type ProductVariantMediaBulkResponse as SchemaProductVariantMediaBulkResponse } from '../schemas/ProductVariantMediaBulkResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const BulkUpdateVariantMediaContentType = 'application/json' as const;
export type BulkUpdateVariantMediaRequest = SchemaProductVariantMediaBulkRequest;
export type BulkUpdateVariantMediaResponses = LinkCommonErrorResponses & {
    /**
     * @description Bulk media update accepted and processed
     */
    '200': {
        'application/json': SchemaProductVariantMediaBulkResponse;
    };
};
export type BulkUpdateVariantMediaResponseSuccess = BulkUpdateVariantMediaResponses['200']['application/json'];
export type BulkUpdateVariantMediaSearchParams = undefined;
export type BulkUpdateVariantMediaPathParameters = undefined;
export const BulkUpdateVariantMediaUrl = '/variants/media' as const;
export const BulkUpdateVariantMediaMethod = 'POST' as const;
export const getBulkUpdateVariantMediaUrl = (_params?: BulkUpdateVariantMediaPathParameters) =>
    BulkUpdateVariantMediaUrl;
